// The bell's escalation titles (#3769 phase 3), one per `EscalationCategory`, ported
// from `packages/agent/src/escalation/titles.ts`. TOTAL over the domain's union, and
// literal keys, so the i18n coverage scan sees every one.

import type { EscalationCategory } from '@developerz/domain';

export const ESCALATION_TITLE_KEY = {
  security: 'notifications.kind.escalation.title_security',
  license: 'notifications.kind.escalation.title_license',
  cla: 'notifications.kind.escalation.title_cla',
  hostile_tone: 'notifications.kind.escalation.title_hostile_tone',
  direct_mention: 'notifications.kind.escalation.title_direct_mention',
  paid_customer: 'notifications.kind.escalation.title_paid_customer',
  breaking_change: 'notifications.kind.escalation.title_breaking_change',
  major_dep_bump: 'notifications.kind.escalation.title_major_dep_bump',
  first_time_contributor: 'notifications.kind.escalation.title_first_time_contributor',
  large_pr: 'notifications.kind.escalation.title_large_pr',
  release_publish: 'notifications.kind.escalation.title_release_publish',
  auto_merge: 'notifications.kind.escalation.title_auto_merge',
  release_shipped: 'notifications.kind.escalation.title_release_shipped',
  pr_merged_first_time_contributor:
    'notifications.kind.escalation.title_pr_merged_first_time_contributor',
  milestone_reached: 'notifications.kind.escalation.title_milestone_reached',
  weekly_streak: 'notifications.kind.escalation.title_weekly_streak',
  cost_cap_reached: 'notifications.kind.escalation.title_cost_cap_reached',
  provider_failure: 'notifications.kind.escalation.title_provider_failure',
  byok_invalid: 'notifications.kind.escalation.title_byok_invalid',
  tool_failure: 'notifications.kind.escalation.title_tool_failure',
  guardrail_violation: 'notifications.kind.escalation.title_guardrail_violation',
  monthly_quota_reached: 'notifications.kind.escalation.title_monthly_quota_reached',
  expectation_accounting: 'notifications.kind.escalation.title_expectation_accounting',
  platform_tooling_issue: 'notifications.kind.escalation.title_platform_tooling_issue',
  credits_exhausted: 'notifications.kind.escalation.title_credits_exhausted',
  pr_babysit_parked: 'notifications.kind.escalation.title_pr_babysit_parked',
  low_confidence: 'notifications.kind.escalation.title_low_confidence',
  ci_timeout: 'notifications.kind.escalation.title_ci_timeout',
} as const satisfies Readonly<Record<EscalationCategory, string>>;
